/**
 * 악덕알리미 약관 및 권한 안내 BS (BottomSheet).
 *
 * 사용:
 *   $j.F.Devil.Terms.open()            // 설정 > '약관 및 권한 안내' (목록 BS)
 *   $j.F.Devil.Terms.viewTerm('terms') // 단일 약관 모달 (가입동의 /b/agree '보기' 등). code: terms|privacy
 *
 * 목록(앱 접근 권한 안내 / 이용약관 / 개인정보처리방침) → 항목 클릭 시 상세 모달.
 *  - 권한 안내 : 앱 기능별 접근 권한 사유. 클라 정적(아래 PERMISSIONS).
 *  - 약관/방침 : 회사 정본을 서버에서 렌더(/b/ajax/settings/terms/{code}).
 * 메모리 "악덕알리미는 JS 클라 렌더링 우선" — Blade 셸 없이 인라인 스타일(테마변수)로 렌더.
 */

// 앱 접근 권한 안내 — 악덕알리미 기능별 권한 사유(실시간 통화감지·경고팝업). 참조 디자인.
const ICO = {
    phone:    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.362 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0122 16.92z" stroke="var(--t2)" stroke-width="1.8"/></svg>',
    contact:  '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z" stroke="var(--t2)" stroke-width="1.8" stroke-linecap="round"/></svg>',
    camera:   '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" stroke="var(--t2)" stroke-width="1.8"/><circle cx="12" cy="13" r="4" stroke="var(--t2)" stroke-width="1.8"/></svg>',
    gallery:  '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" rx="2" stroke="var(--t2)" stroke-width="1.8"/><circle cx="8.5" cy="8.5" r="1.5" stroke="var(--t2)" stroke-width="1.3"/><path d="M21 15l-5-5L5 21" stroke="var(--t2)" stroke-width="1.8" stroke-linecap="round"/></svg>',
    overlay:  '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 6a2 2 0 012-2h9a2 2 0 012 2v3h-3a2 2 0 00-2 2v6H6a2 2 0 01-2-2z" stroke="var(--t2)" stroke-width="1.8" stroke-linejoin="round"/><rect x="9" y="9" width="11" height="11" rx="2" stroke="var(--t2)" stroke-width="1.8"/></svg>',
    bell:     '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M6.4 8a5.6 5.6 0 0111.2 0l.3 2.3c.1 1.1.5 2.2 1.1 3.2l.6 1c.5.9.8 1.3.7 1.7a1 1 0 01-.3.6c-.3.2-.8.2-1.8.2H5.9c-1 0-1.5 0-1.8-.2a1 1 0 01-.3-.6c-.1-.4.2-.8.7-1.7l.6-1c.6-1 .9-2.1 1.1-3.2z" stroke="var(--t2)" stroke-width="1.8"/><path d="M8 17a4 4 0 008 0" stroke="var(--t2)" stroke-width="1.8" stroke-linecap="round"/></svg>',
    battery:  '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="3" y="7" width="16" height="10" rx="2" stroke="var(--t2)" stroke-width="1.8"/><path d="M21 10v4" stroke="var(--t2)" stroke-width="1.8" stroke-linecap="round"/><rect x="6" y="10" width="5" height="4" fill="var(--t2)"/></svg>',
};
// (2026-10-02) 개인정보처리방침 제8조·앱 첫 실행 권한 화면(dv PermissionScreen.kt)·원스토어 콘솔과 같은 문안.
// 앱이 실제로 선언·요청하는 권한만 적는다 — dv AndroidManifest·AppPermissions·MainActivity 특수권한 요청과 1:1.
//  - 연락처의 실제 용도는 제보 폼의 [주소록] 번호 가져오기(Pages/Devil/Report.js). 옛 "안심번호 통화 연결"은 틀렸다.
//  - '다른 앱 위에 표시'(경고 팝업)·'배터리 최적화 제외'는 설정 화면으로 보내 받는 특수 권한 — 고지 목록에는 들어간다.
//  - 위치 권한은 앱에 없다(2026-09-14 기획 피드백으로 뺀 뒤 그대로).
const PERMISSIONS = [
    { ic: ICO.phone,    name: '전화 통화기록',     req: true,  desc: '통화 중 체불업체 감지 (통화 상대 번호 대조)' },
    { ic: ICO.overlay,  name: '다른 앱 위에 표시', req: true,  desc: '통화 중 체불업체 경고 팝업 표시' },
    { ic: ICO.bell,     name: '알림',              req: false, desc: '제보 처리 결과 등 푸시 알림 수신' },
    { ic: ICO.battery,  name: '배터리 최적화 제외', req: false, desc: '절전모드에서도 통화 감지 유지' },
    { ic: ICO.contact,  name: '연락처',            req: false, desc: '제보 시 주소록에서 연락처 선택' },
    { ic: ICO.camera,   name: '카메라',            req: false, desc: '체불 증빙자료 촬영' },
    { ic: ICO.gallery,  name: '갤러리',            req: false, desc: '체불 증빙자료 첨부' },
];

// 접근 권한 본문 (탭 '접근권한') — 참조 디자인: 원형 아이콘 + 필수/선택 배지 + 참고사항
function permBody() {
    const note = (t) => `<p style="font-size:12px;color:var(--t2);line-height:1.6;padding-left:12px;text-indent:-12px">• ${t}</p>`;
    return PERMISSIONS.map(p => `
        <div style="display:flex;align-items:center;gap:12px;padding:10px 0">
            <div style="width:42px;height:42px;border-radius:21px;background:var(--sf2);display:flex;align-items:center;justify-content:center;flex-shrink:0">${p.ic}</div>
            <div>
                <p style="font-size:14px;font-weight:600;color:var(--t1)">${esc(p.name)} <span style="font-size:12px;font-weight:400;color:${p.req ? 'var(--R)' : 'var(--t2)'}">(${p.req ? '필수' : '선택'})</span></p>
                <p style="font-size:12px;color:var(--t2);margin-top:2px;line-height:1.5">${esc(p.desc)}</p>
            </div>
        </div>`).join('')
        + `<div style="border-top:1px solid var(--sf2);padding-top:12px;margin-top:4px">
             <p style="font-size:13px;font-weight:600;color:var(--t3);margin-bottom:8px">참고사항</p>
             ${note('접근 권한은 설정 → 앱 → 악덕알리미 → 권한에서 변경 가능합니다.')}
             ${note('필수 권한(전화 통화기록·다른 앱 위에 표시) 미허용 시 통화 중 체불업체 감지와 경고 팝업이 동작하지 않습니다.')}
             ${note('선택 권한 미허용 시 일부 기능이 제한될 수 있습니다.')}
           </div>`;
}

// 단일 약관 BottomSheet (b/agree '보기' 등 — 모달 대신 BS). fixedHeight → content-area 스크롤
// opts.onAgree 를 주면 동의 모드 — 하단에 '끝까지 읽어주세요 ↓'(잠금) 버튼, 본문을 끝까지 내리면 '동의합니다'로 켜지고
// 누르면 onAgree() + 시트 닫기. opts.agreed(이미 동의한 항목)면 처음부터 켜진다. (2026-09-14 기획 — 제보 동의, 엑셀 106·107)
function showTermBS(code, opts = {}) {
    const consent = typeof opts.onAgree === 'function';
    $j.Ui.BS.open({
        fixedHeight: true,
        backClose: true,
        target: {
            init() {
                const $cont = $('#' + this.id);
                const parent = this.parent;
                $cont.off('.tmConsent');
                // 헤더는 「약관」, 약관 이름은 본문 첫머리 큰 제목 — 내려 읽으면 헤더 제목이 약관 이름으로 바뀐다(collapseTitle)
                parent.setHeader({ loading: true });
                $cont.html('<p style="color:var(--t3);font-size:14px;padding:24px 0;text-align:center">불러오는 중…</p>');
                fetch('/b/ajax/settings/terms/' + encodeURIComponent(code))
                    .then(r => r.json())
                    .then(res => {
                        parent.setHeader({ title: '약관' });
                        if (!res || !res.result) { $cont.html(`<p style="color:var(--t3);font-size:14px;padding:24px">${esc(res && res.message || '불러오기 실패')}</p>`); return; }
                        $cont.html(`<div class="tm-doc" style="padding:16px;font-size:13px;color:var(--t2);line-height:1.75;word-break:break-word">${docTitle(res.title || '약관')}${res.body || ''}</div>`
                            + (consent ? '<div class="tm-consent"><button type="button" class="tm-consent__btn is-locked">끝까지 읽어주세요 <span aria-hidden="true">↓</span></button></div>' : ''));
                        parent.collapseTitle($cont.find('.tm-doc__title'));
                        if (consent) bindConsentFoot($cont, parent, opts);
                    })
                    .catch(() => { parent.setHeader({ title: '약관' }); $cont.html('<p style="color:var(--t3);font-size:14px;padding:24px">네트워크 오류</p>'); });
            },
            // 시트 DOM(.content-area)은 다음 시트가 재사용한다 — 동의 모드 스크롤 리스너를 떼어 둔다
            destroy() { $('#' + this.id).off('.tmConsent'); },
        },
    });
}

// 동의 모드 하단 버튼 — 끝까지 스크롤(다 읽음)해야 활성. /m 위치동의 약관 뷰어(F/Mobile/LocationGate._openTerm)와 같은 판정.
// 잠금은 disabled 가 아니라 .is-locked — 잠긴 채 누르면 본문을 맨 아래로 부드럽게 내려준다(클릭 이벤트가 와야 해서).
// 스크롤러는 시트 본문(.content-area) 자신이다. 글자크기 zoom 이 걸려 있어도 scrollHeight·scrollTop·clientHeight 는 같은 단위라 그대로 비교한다.
function bindConsentFoot($cont, bs, opts) {
    const el = $cont[0];
    const $btn = $cont.find('.tm-consent__btn');
    let ro = null;
    const enable = () => {
        $btn.removeClass('is-locked').text('동의합니다');
        $cont.off('scroll.tmConsent');
        if (ro) { ro.disconnect(); ro = null; }
    };
    const atBottom = () => el.scrollHeight - el.scrollTop - el.clientHeight <= 8;   // 바닥 근처(짧아서 스크롤이 없는 경우 포함)
    const tryEnable = () => { if (opts.agreed || atBottom()) { enable(); return true; } return false; };

    $cont.on('scroll.tmConsent', tryEnable);
    $btn.on('click', () => {
        if ($btn.hasClass('is-locked')) {
            const top = el.scrollHeight - el.clientHeight;
            try { el.scrollTo({ top, behavior: 'smooth' }); } catch (e) { el.scrollTop = top; }
            setTimeout(tryEnable, 400);
            setTimeout(tryEnable, 900);
            return;
        }
        opts.onAgree();
        bs.close();
    });

    if (tryEnable()) return;
    // 웹뷰는 시트 레이아웃이 늦게 잡혀 즉시 판정이 이르다 — 크기가 확정되는 순간 재판정 + 지연 폴백
    if (window.ResizeObserver) { ro = new ResizeObserver(() => tryEnable()); ro.observe(el); }
    setTimeout(tryEnable, 200);
    setTimeout(tryEnable, 600);
}

// 약관 변경예정안 BS — 현행/개정안 조항 비교(모바일은 조 단위 세로 카드)
function showChangesBS(code) {
    $j.Ui.BS.open({
        fixedHeight: true,
        backClose: true,
        target: {
            init() {
                const $cont = $('#' + this.id);
                const parent = this.parent;
                // 단일 약관과 같은 모양 — 헤더 「약관 개정 안내」, 본문 큰 제목 「○○ 개정 안내」가 가려지면 헤더로 올라간다
                parent.setHeader({ loading: true });
                $cont.html('<p style="color:var(--t3);font-size:14px;padding:24px 0;text-align:center">불러오는 중…</p>');
                fetch('/b/ajax/settings/terms/' + encodeURIComponent(code) + '/changes')
                    .then(r => r.json())
                    .then(res => {
                        parent.setHeader({ title: '약관 개정 안내' });
                        if (!res || !res.result) { $cont.html(`<p style="color:var(--t3);font-size:14px;padding:24px">${esc(res && res.message || '불러오기 실패')}</p>`); return; }
                        $cont.html(docTitle((res.title || '약관') + ' 개정 안내') + renderChanges(res));
                        parent.collapseTitle($cont.find('.tm-doc__title'));
                    })
                    .catch(() => { parent.setHeader({ title: '약관 개정 안내' }); $cont.html('<p style="color:var(--t3);font-size:14px;padding:24px">네트워크 오류</p>'); });
            },
        },
    });
}
function renderChanges(res) {
    if (!res.has_changes) return '<p style="padding:28px;text-align:center;color:var(--t3)">예정된 약관 변경이 없습니다.</p>';
    const color = { '신설': 'var(--C)', '개정': 'var(--B)', '삭제': 'var(--t2)' };
    const clauses = (a) => (a && a.clauses && a.clauses.length) ? a.clauses.map(esc).join('<br>') : '<span style="color:var(--t3)">-</span>';
    const head = res.effective_from
        ? `<p style="padding:0 0 12px;color:var(--t2);font-size:13px">시행일 <b>${esc(res.effective_from)}</b></p>` : '';
    const rows = res.rows.map(r => `
        <div style="border:1px solid var(--bdr);border-radius:10px;padding:12px;margin-bottom:12px">
            <div style="margin-bottom:8px">
                <span style="background:${color[r.status] || 'var(--t2)'};color:var(--on-brand);font-size:11px;padding:2px 8px;border-radius:10px">${esc(r.status)}</span>
                <b style="margin-left:6px;color:var(--t1)">${esc(r.no)}</b> <span style="color:var(--t3)">${esc(r.title)}</span>
            </div>
            <div style="font-size:11px;color:var(--t2);margin-bottom:2px">현행</div>
            <div style="font-size:13px;color:var(--t2);line-height:1.6;margin-bottom:8px">${clauses(r.current)}</div>
            <div style="font-size:11px;color:var(--t2);margin-bottom:2px">개정(안)</div>
            <div style="font-size:13px;color:var(--t1);line-height:1.6">${clauses(r.draft)}</div>
            ${r.change_note ? `<div style="margin-top:8px;font-size:12px;color:var(--R);white-space:pre-line">${esc(r.change_note)}</div>` : ''}
        </div>`).join('');
    return `<div style="padding:16px">${head}${rows}</div>`;
}

// ── 탭형 BS (설정 > 약관 및 권한 안내) ────────────────────────────────
//   참조 디자인: BS 헤더 아래 고정 탭(이용약관/개인정보/접근권한) + 스크롤 본문.
//   terms·privacy = DB 현행버전 fetch, perm = 정적. 탭별 본문 캐시(재조회 방지).
const TABS = [
    { key: 'terms',   label: '이용약관' },
    { key: 'privacy', label: '개인정보' },
    { key: 'perm',    label: '접근권한' },
];

function buildTarget() {
    const cache = {};

    return {
        init() {
            const $cont = $('#' + this.id);
            this.parent.setTitle('약관 및 권한 안내');
            // 탭은 헤더 아래 띠(setBand) — 본문을 내려도 남는다. 본문 스크롤은 시트 본문(.content-area)이 한다.
            const $tabs = $(tabsHtml());
            this.parent.setBand($tabs);
            $tabs.on('click', '.tm-tab', function () { load($cont, $tabs, $(this).data('tab')); });
            $cont.html('<div class="tm-body" style="padding:4px 8px 30px"></div>');
            load($cont, $tabs, 'terms');   // 기본 탭
        },
        destroy() {},
    };

    function tabsHtml() {
        const tab = (t) => `<button class="tm-tab" data-tab="${t.key}" style="flex:1;padding:10px 0;text-align:center;font-size:13px;
                font-weight:500;color:var(--t3);background:none;border:none;border-bottom:2px solid var(--sf2);cursor:pointer">${t.label}</button>`;
        return `<div class="tm-tabs" style="display:flex">${TABS.map(tab).join('')}</div>`;
    }

    function setActive($tabs, key) {
        $tabs.find('.tm-tab').each(function () {
            const on = $(this).data('tab') === key;
            $(this).css({ 'font-weight': on ? 700 : 500, color: on ? 'var(--R)' : 'var(--t3)', 'border-bottom': '2px solid ' + (on ? 'var(--R)' : 'var(--sf2)') });
        });
    }

    function load($cont, $tabs, key) {
        setActive($tabs, key);
        const $body = $cont.find('.tm-body');
        $cont.scrollTop(0);

        if (cache[key] !== undefined) { $body.html(cache[key]); return; }

        if (key === 'perm') { cache[key] = permBody(); $body.html(cache[key]); return; }

        $body.html('<p style="color:var(--t3);font-size:14px;padding:24px 0;text-align:center">불러오는 중…</p>');
        fetch('/b/ajax/settings/terms/' + encodeURIComponent(key))
            .then(r => r.json())
            .then(res => {
                const html = (res && res.result)
                    ? `<div class="tm-doc" style="font-size:13px;color:var(--t2);line-height:1.75;word-break:break-word">${res.body || ''}</div>`
                    : `<p style="color:var(--t3);font-size:14px;padding:24px 0;text-align:center">${esc(res && res.message || '불러오기 실패')}</p>`;
                cache[key] = html;
                $body.html(html);
            })
            .catch(() => $body.html('<p style="color:var(--t3);font-size:14px;padding:24px 0;text-align:center">네트워크 오류</p>'));
    }
}

// 본문 첫머리 큰 제목 — collapseTitle 이 이 줄이 가려지는지 본다
function docTitle(t) {
    return `<h3 class="tm-doc__title" style="margin:0 0 12px;font-size:18px;font-weight:700;line-height:1.35;color:var(--t1)">${esc(t)}</h3>`;
}

function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

export default class Terms {
    open = () => {
        $j.Ui.BS.open({ target: buildTarget(), fixedHeight: true, backClose: true });
    }
    // 단일 약관 — b/agree '보기' 는 BS(BottomSheet)로
    viewTerm = (code) => showTermBS(code);
    // 제보 작성 동의 — DB 약관(report_privacy|report_3rd|report_notice)을 BS로
    // 제보 동의 — opts {agreed, onAgree} 를 주면 끝까지 읽어야 '동의합니다'가 켜지는 동의 모드(showTermBS 주석)
    viewConsent = (code, opts = {}) => showTermBS(code, opts);
    // 동의 발판만 빌려 쓰기 — 소명 화면(Pages/Devil/Defense)처럼 본문이 DB 약관이 아니거나 시트가 BS 가 아닌 곳.
    //   $cont: 스크롤되는 본문 요소(jQuery) — 그 끝에 .tm-consent 버튼이 들어 있어야 한다. close: 시트를 닫는 함수.
    bindConsentFoot = ($cont, close, opts = {}) => bindConsentFoot($cont, { close }, opts);
    // 약관 변경예정안(현행 vs 시행예정 개정안) BS — code: terms|privacy 등
    viewChanges = (code) => showChangesBS(code);
}
